import React from 'react';
import { Search, Droplets, Sparkles, CheckCircle } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      icon: Search,
      title: 'Inspection',
      description: 'We thoroughly assess your vehicle\'s paint and fabric condition to determine the best approach.'
    },
    {
      icon: Droplets,
      title: 'Preparation',
      description: 'Pre-wash foam bath carefully lifts dirt and grime without scratching your vehicle\'s surface.'
    },
    {
      icon: Sparkles,
      title: 'The Detail',
      description: 'Precise cleaning using professional-grade tools and premium products for exceptional results.'
    },
    {
      icon: CheckCircle,
      title: 'Final Walkthrough',
      description: 'You inspect our work before we leave. Your satisfaction is our top priority.'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Process <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400">Transparency</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Our proven 4-step process ensures consistent, premium results every time
          </p>
        </div>

        <div className="relative">
          {/* Desktop: Horizontal Timeline */}
          <div className="hidden md:block">
            {/* Connection Line */}
            <div className="absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-yellow-500/20 via-yellow-500/50 to-yellow-500/20"></div>
            
            <div className="grid md:grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  {/* Number Badge */}
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 rounded-full bg-gradient-to-r from-yellow-500 to-amber-400 flex items-center justify-center text-black font-bold text-sm z-10">
                    {index + 1}
                  </div>

                  {/* Card */}
                  <div className="bg-zinc-900/50 backdrop-blur-sm border border-yellow-500/20 rounded-xl p-6 hover:border-yellow-500 transition-all duration-300 hover:scale-105 mt-8">
                    <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-yellow-500/20 to-amber-400/20 flex items-center justify-center mb-4 mx-auto">
                      <step.icon className="w-8 h-8 text-yellow-400" />
                    </div>
                    <h3 className="text-xl font-bold text-white text-center mb-3">{step.title}</h3>
                    <p className="text-gray-400 text-sm text-center">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile: Vertical Timeline */}
          <div className="md:hidden space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="relative pl-12">
                {/* Timeline Line */}
                {index !== steps.length - 1 && (
                  <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-yellow-500/30"></div>
                )}

                {/* Number Badge */}
                <div className="absolute left-0 top-0 w-12 h-12 rounded-full bg-gradient-to-r from-yellow-500 to-amber-400 flex items-center justify-center text-black font-bold">
                  {index + 1}
                </div>

                {/* Card */}
                <div className="bg-zinc-900/50 backdrop-blur-sm border border-yellow-500/20 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-yellow-500/20 to-amber-400/20 flex items-center justify-center flex-shrink-0">
                      <step.icon className="w-6 h-6 text-yellow-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white mb-2">{step.title}</h3>
                      <p className="text-gray-400 text-sm">{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
